import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      black: '#000000',
      white: '#ffffff',
      ltGray1: '#f2f2f2',
      ltGray2: '#e8e8e8',
      dkGray1: '#c8c8c8',
      dkGray2: '#4c4d4f',
      ltRed: '#cf102d',
      dkRed: '#ab192d',
      ltPurple: '#b588b9',
      dkPurple: '#94368d',
      ltBlue: '#3db5e6',
      dkBlue: '#006aa7',
      ltGreen: '#6bc04b',
      dkGreen: '#009946',
      ltYellow: '#f3ce00',
      dkYellow: '#d08a00',
      red: '#cf102d'
    }
  },
  fonts: {
    heading: '"Overpass", "Interstate", sans-serif',
    body: '"Overpass", "Interstate", sans-serif'
  },
  components: {
    Checkbox: {
      baseStyle: {
        control: {
          borderColor: 'brand.dkGray2',
          _checked: {
            borderColor: 'brand.dkBlue',
            bg: 'brand.dkBlue',
          }
        }
      }
    }
  },
  styles: {
    global: {
      body: {
        bg: 'brand.ltGray1',
        color: 'brand.dkGray2'
      }
    }
  }
});

export default theme;
